(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["helix-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
const link=event.target.closest('[data-hx-open-comparison]');
if(!link)return;
const panel=document.getElementById('hx-collection-comparison');
if(panel)panel.open=true;
});
  } catch(e) { console.error(e); }
})();

})();
